<template>
  <Popup :header="''" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>
      {{ infoText }}
    </template>
    <template v-slot:accept-btn-label>{{ buttonText }}</template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';

export default {
  name: 'BestaetigenPopup',
  components: { Popup },
  props: {
    infoText: {
      type: String,
      default: "Sind sie sicher?",
    },
    buttonText: {
      type: String,
      default: "Bestätigen",
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('cancel');
    },
    acceptAndClose() {
      this.$emit('confirm');
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
